import { Blueprint } from 'types';

/**
 * Extracts both hybrid and conventional calculations from blueprint
 * Base calculation (isBaseCalculation: true) is the conventional setup without batteries
 * Non-base calculation (isBaseCalculation: false) is the hybrid setup with batteries
 * @param blueprint - Blueprint data
 * @returns Object with hybrid and conventional calculations (undefined if not found)
 */
export const getBlueprintCalculations = (blueprint?: Blueprint) => {
  const conventional = blueprint?.calculations?.find((calc) => calc.isBaseCalculation);
  const hybrid = blueprint?.calculations?.find((calc) => !calc.isBaseCalculation);
  const mainsConnectionMaxAmps = hybrid?.powerSetup?.mainsConnectionMaxAmps ?? null;
  const mainsConnectionMaxKw = hybrid?.powerSetup?.mainsConnectionMaxKw ?? null;
  const hasGrid = !!mainsConnectionMaxAmps || !!mainsConnectionMaxKw;
  const hasKite = !!hybrid?.powerSetup?.kitePowerScenario;

  return { hybrid, conventional, hasGrid, hasKite, mainsConnectionMaxAmps, mainsConnectionMaxKw };
};
